require("tooltipster");

import UrlHelper from "../Helper/Url";

// Tooltipster START
$('.blb-content-container .blb-link > a[title]').not('a[title=""]').tooltipster({
    side: ['left', 'right'],
    maxWidth: 305,
    distance: 25,
});
$('.blb-content-container a[title]').not('a[title=""]').not($(this).parent('.blb-link')).tooltipster({
    side: ['left', 'right'],
    maxWidth: 305,
});
// Tooltipster END

// Smooth Anchor Jump START
$(document).on('click', '.blb-content-container a[href*="#"]', (event) => {
    let pad     = UrlHelper.getUrlWithoutAnchor($(event.currentTarget).attr('href')),
        anchor  = UrlHelper.getAnchor($(event.currentTarget).attr('href'));

    // Sometimes we only get an anchor, sometimes it is prefixed so we have to catch all exceptions here
    // #anchor | https://foo/bar#anchor | /bar#anchor
    if( pad.length < 1 || UrlHelper.getUrlWithoutAnchor() == pad || document.location.pathname == pad ) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $( '#' + anchor ).offset().top
        }, 500);
        document.location = UrlHelper.getUrlWithoutAnchor() + '#' + anchor;
    }
});
// Smooth Anchor Jump END